function padDatePart(value) {
  return String(value).padStart(2, "0");
}

function isValidCalendarDate(year, month, day) {
  const date = new Date(Date.UTC(year, month - 1, day));
  return (
    date.getUTCFullYear() === year &&
    date.getUTCMonth() === month - 1 &&
    date.getUTCDate() === day
  );
}

export function normalizeBirthDateInput(value) {
  return String(value || "")
    .trim()
    .replace(/\//g, "-")
    .replace(/\./g, "-")
    .replace(/\s+/g, "");
}

export function formatBirthDateInput(value) {
  return normalizeBirthDateInput(value).slice(0, 10);
}

export function parseBirthDateInput(value) {
  const normalizedValue = normalizeBirthDateInput(value);

  if (!normalizedValue) {
    return {
      normalizedValue: "",
      isoDate: null,
      isValid: false,
    };
  }

  let year;
  let month;
  let day;

  let match = normalizedValue.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  if (match) {
    [, year, month, day] = match;
  } else {
    match = normalizedValue.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
    if (!match) {
      return {
        normalizedValue,
        isoDate: null,
        isValid: false,
      };
    }

    [, day, month, year] = match;
  }

  const yearNumber = Number(year);
  const monthNumber = Number(month);
  const dayNumber = Number(day);

  if (!isValidCalendarDate(yearNumber, monthNumber, dayNumber)) {
    return {
      normalizedValue,
      isoDate: null,
      isValid: false,
    };
  }

  return {
    normalizedValue,
    isoDate: `${yearNumber}-${padDatePart(monthNumber)}-${padDatePart(dayNumber)}`,
    isValid: true,
  };
}

export function getBirthDateValidationError(value, maxBirthDate) {
  const normalizedValue = normalizeBirthDateInput(value);

  if (!normalizedValue) {
    return "This field is required";
  }

  const parsedDate = parseBirthDateInput(normalizedValue);
  if (!parsedDate.isValid || !parsedDate.isoDate) {
    return "Use YYYY-MM-DD or DD-MM-YYYY";
  }

  if (maxBirthDate && parsedDate.isoDate > maxBirthDate) {
    return `Birth date must be on or before ${maxBirthDate}`;
  }

  return "";
}
